import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function About(){
  return(
    <section style={{marginTop:50}}>
    <h1 style={{fontWeight: 'bold', color: '#0116D5'}}>About Me</h1>
    <Container style={{marginTop:50}}>
    <Row>
      <Col xs={12} md={8}>
        <h5 style={{textAlign: 'justify', marginTop:'60'}}>Hello, My name is Ratul Sarkar. I'm a passionate photographer. I grew up in Tripura and my interest in photography started in 2014.
        I capture my frames very instinctively. I see how it is taken like that. Creative & Smart Ideas when comes to life visualising the world through my lens! I like to capture macro, low light portraits & lanscape. </h5>
        <br/><h5 style={{textAlign: 'justify'}}>I'm a Front-end Developer | UI designer | Web Designer & portfolio specialist based in India with experience of almost 2 years.
        I'm currently working in a startup Raceteq Union, Maharastra as a Front-end Developer | UI designer | Web Designer.
        I have also been working as a lancer. I'm open to taking up good projects.
        If you are having some good projects/ideas, please feel free to contact me.</h5>
      </Col>
      <Col xs={12} md={4}>
        <img src="./photos/avatar.jpg" style={{width : '100%', borderRadius: 20}}/>
      </Col>
    </Row>
  </Container>
  </section>
  )
}
export default About;
